import { highlightTechTerms } from './tech-terms';
import { normalizeSpeakerNamesInText } from './speaker-display-names';

function escapeHtml(text: string): string {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}

/** **Жирный** → HTML; таймкоды (6:50) удаляются из текста протокола. */
export function formatProtocolRichText(text: string): string {
  if (!text?.trim()) return '';

  let html = escapeHtml(
    normalizeSpeakerNamesInText(text)
      .trim()
      .replace(/\s*\(\d{1,2}:\d{2}\)/g, '')
      .replace(/\s*\[\d{1,2}:\d{2}\]/g, ''),
  );
  html = html.replace(/(?<!\*)\*([^*\n]{2,80})\*\*(?!\*)/g, '<strong class="protocol-action">$1</strong>');
  html = html.replace(/\*\*(.+?)\*\*/g, '<strong class="protocol-action">$1</strong>');
  return highlightTechTerms(html);
}
